//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import Filters from './FrontConfigAccessesFilters.vue';
import Extra from './FrontConfigAccessesExtra.vue';

import tableConfig from './tableConfig';
import actionsConfig from './actionsConfig';
import constant from '~/const';

export default {
  components: { Filters, Extra },

  data() {
    return {
      tableConfig,
      actionsConfig,
      selection: [],
      loader: false,
      constant,
      changingGroup: {
        modal: false,
        data: {},
      },
      settingApps: {
        modal: false,
        data: {},
      },
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('frontConfigAccesses', [
      'page',
      'pages',
      'data',
      'sort',
      'appList',
    ]),

    accessesAppList() {
      return this.appList.filter((e) => e.isWhiteList);
    },

    bansAppList() {
      return this.appList.filter((e) => !e.isWhiteList);
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('frontConfigAccesses', {
      loadDataAction: 'loadData',
      loadAppListAction: 'loadAppList',
      getGroupAction: 'getGroup',
      setPageAction: 'setPage',
      setSortAction: 'setSort',
      createGroupAction: 'createGroup',
      updateGroupAction: 'updateGroup',
      removeGroupAction: 'removeGroup',
      addUserToGroupAction: 'addUserToGroup',
      removeUserFromGroupAction: 'removeUserFromGroup',
      getUserGroupsAction: 'getUserGroups',
      getGroupUsersAction: 'getGroupUsers',
      updateAppAction: 'updateApp',
      denyAction: 'deny',
      allowAction: 'allow',
      resetAction: 'reset',
    }),

    async loadData(data = {}) {
      this.setGeneralProgress(true);
      this.loader = true;
      await this.loadDataAction(data);
      this.setGeneralProgress(false);
      this.loader = false;
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData();
    },

    applySort(data) {
      this.setSortAction(data);
      this.loadData();
    },

    setPage(value) {
      this.setPageAction(value);

      const extendedRequestData = {
        getTotal: false,
      };

      this.loadData(extendedRequestData);
    },

    actionHandler({ action, payload }) {
      this[action](payload);
    },

    getAccessesList(row) {
      const { items } = row;
      return items.filter((e) => e.type === constant.frontConfig.ACCESS_TYPE.ALLOW);
    },

    getBansList(row) {
      const { items } = row;
      return items.filter((e) => e.type === constant.frontConfig.ACCESS_TYPE.DENY);
    },

    changeGroup(row) {
      this.changingGroup.data = { ...row };
      this.changingGroup.modal = true;
    },

    deleteGroup(row) {
      const { groupId } = row;

      this.confirmAction({
        title: 'Are you sure you want to delete group?',
        callback: async () => {
          this.setGeneralProgress(true);
          await this.removeGroupAction({
            id: groupId,
          });
          this.loadData();
          this.setGeneralProgress(false);
          this.setSuccessNotification('Group successfully deleted');
        },
      });
    },

    getAppAccessValue(item, type) {
      const { items } = this.changingGroup.data;
      if (!items) return false;

      return items.some((e) => (
        e.applicationName === item.name && e.type === type
      ));
    },

    async setAppAccessValue(item, type, value) {
      const { id: appId } = item;
      const { groupId } = this.changingGroup.data;
      this.setGeneralProgress(true);
      this.loader = true;
      if (value) {
        if (type === constant.frontConfig.ACCESS_TYPE.ALLOW) {
          await this.allowAction({ appId, groupId });
        } else {
          await this.denyAction({ appId, groupId });
        }
      } else {
        await this.resetAction({ appId, groupId });
      }
      this.changingGroup.data = await this.getGroupAction({ groupId });
      await this.loadDataAction();
      this.loader = false;
      this.setGeneralProgress(false);
      this.setSuccessNotification('Group updated');
    },

    async setGroupName() {
      const { groupId, groupName } = this.changingGroup.data;
      this.setGeneralProgress(true);
      this.loader = true;
      await this.updateGroupAction({
        id: groupId,
        newName: groupName,
      });
      await this.loadDataAction();
      this.loader = false;
      this.setGeneralProgress(false);
      this.changingGroup.modal = false;
      this.setSuccessNotification('Group updated');
    },

    addGroup() {
      this.confirmAction({
        title: 'Are you sure you want to create group?',
        hasPrompt: true,
        promptRequired: true,
        promptLabel: 'Name',
        callback: async ({ prompt }) => {
          this.setGeneralProgress(true);
          this.loader = true;
          await this.createGroupAction({ groupName: prompt });
          await this.loadDataAction();
          this.loader = false;
          this.setGeneralProgress(false);
          this.setSuccessNotification('Group created');
        },
      });
    },

    setApps() {
      this.settingApps.modal = true;
    },

    async setAppPrivacy(item, value) {
      this.setGeneralProgress(true);
      this.loader = true;
      await this.updateAppAction({
        params: {
          appId: item.id,
        },
        data: {
          isWhiteList: value,
        },
      });
      await this.loadAppListAction();
      this.loader = false;
      this.setGeneralProgress(false);
      this.setSuccessNotification('Group updated');
    },
  },
};
